import { Routes } from '@angular/router';

import { createTranslocoScope } from '@gde-mit/angular-core';

export const SHARED_TRANSLOCO = createTranslocoScope('SHARED', (lang) => import(`./shared/i18n/${lang}.json`));

export const APP_ROUTES_CONST = {
  DEFAULT: '',
};

const APP_ROUTES: Routes = [
  {
    path: APP_ROUTES_CONST.DEFAULT,
    loadChildren: () => import('./features/kt/kt.routes'),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: APP_ROUTES_CONST.DEFAULT,
  },
];

export default APP_ROUTES;
